import createAction from '../services/create-action';

export const FETCH_NOTIFICATIONS_REQUEST = 'notifications/REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'notifications/SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'notifications/FAILURE';

export const fetchNotificationsRequest = createAction(FETCH_NOTIFICATIONS_REQUEST);
export const fetchNotificationsSuccess = createAction(FETCH_NOTIFICATIONS_SUCCESS);
export const fetchNotificationsFailure = createAction(FETCH_NOTIFICATIONS_FAILURE);

export const fetchNotifications = () => (dispatch, getState, { request }) => {
  dispatch(fetchNotificationsRequest());

  const promise = request(`/_api/notifications`);

  return promise
    .then(notifications => dispatch(fetchNotificationsSuccess(notifications)))
    .catch(() => dispatch(fetchNotificationsFailure()))
    .then(() => promise);
};



// WEBPACK FOOTER //
// ./app/actions/fetch-notifications.js